import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class FormAssistanceService {

  formAssistanceOpenEvent: EventEmitter<Object> = new EventEmitter();
  formAssistanceCloseEvent: EventEmitter<Object> = new EventEmitter();
  annotationSelectedEvent = new Subject<any>();
  clearAnnotationDetailsEvent: EventEmitter<Object> = new EventEmitter();
  updateAnnotationListEvent = new Subject<boolean>();

  constructor(private http: HttpClient) { }

  createAnnotation(agentId: string, documentId: string, queryParam: any) {
    const data = {field_data: queryParam};
    return this.http.post(environment.va_service_api + 'form-assistant/' + agentId + '/create/' + documentId, data)
  }

  updateAnnotation(agentId: string, annotationId: string, queryParam: any) {
    delete queryParam._id;
    delete queryParam.annot_id;
    const data = {field_data: queryParam};
    return this.http.post(environment.va_service_api + 'form-assistant/' + agentId + '/update/' + annotationId, data)
  }

  deleteAnnotation(agentId: string, annotationId: string) {
    return this.http.delete(environment.va_service_api + 'form-assistant/' + agentId + '/delete/' + annotationId)
  }

  listAnnotation(agentId: string, documentId: string) {
    return this.http.get(environment.va_service_api + 'form-assistant/' + agentId + '/list-form-annotation/' + documentId)
  }

  listFormAssistantTemplate(agentId: string) {
    return this.http.get(environment.va_service_api + 'form-assistant/' + agentId + '/form-assistant-template-list')
  }

}
